// Home.backoffice

module.exports = {  
  groupsDependancesMsg: {
    en: "No dependencies",
    fr: "Pas de dépendances"
  },
  usersDependancesMsg: {
    en: "No dependencies",
    fr: "Pas de dépendances"
  },
  appsDependancesMsg: {
    en: "No dependencies",
    fr: "Pas de dépendances"
  },
  servicesDependancesMsg: {
    en: "To access this service, at least one application is required",
    fr: "Pour acceder à ce service, vous devez avoir accès à au moins une application"
  },
  apisDependancesMsg: {
    en: "To access this service, at least one database is required",
    fr: "Pour acceder à ce service, vous devez avoir accès à au moins une base de données"
  },
  licencesDependancesMsg: {
    en: "To access this service, at least one module of pricing is required",
    fr: "Pour acceder à ce service, vous devez avoir accès à au moins un module de prix/fonctionnalités"
  },
  themeDependancesMsg: {
    en: "No dependencies",
    fr: "Pas de dépendances"
  },  
  title: {
    en: "Plateform",
    fr: "Plateforme"
  },
  groups: require("./groups"),
  apis: require("./apis"),
  licences: require("./licences"),
  services: require("./services"),
  apps: require("./apps"),
  profiles: require("./profiles"),
  users: require("./users"),
  cards: require("./cards"),
  theme: require("./theme")
};
